<template>
      <div class="col-md-12 text-center">
        <div class="action-container">
          <div class="action-symbol">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          </div>
          <div class="action-desc row">
            <p>Your will be redirected to Piraeus Payment Gateyway.<br> Press "Pay with Card or Pay with MasterPass" to continue to payment!
            </p>
          </div>
          <div class="row padd20t padd20b" id="form-billing">
            <div class="text-left ">
               <div class="form-group col-md-10 col-md-offset-1">
                              <label class="control-label">
                                Billing address
                            </label>
                            <input type="text" class="form-control" name="billAddress" placeholder="Address" required />
                            
                          </div>
                           <div class="form-group col-md-6 col-md-offset-1">
                             <input type="text" class="form-control" name="billCity" placeholder="City"/ required>
              </div>
               <div class="form-group col-md-4">
                             <input type="text" class="form-control" name="billZip" placeholder="Zip Code"/ required>
              </div>
               <div class="form-group col-md-10 col-md-offset-1">
                             <input type="text" class="form-control" name="billState" placeholder="State" required />
              </div>
               <div class="form-group col-md-10 col-md-offset-1">
                  <input type="hidden" name="billCountry">
                  <input type="text">
              </div>
            </div>
          </div>

        </div>

        <div class="row padd20t">
          <div class="padd20t col-md-12"><button type="button" id="winbankButton" class="btn btn-rengine btn-flat" name="Pay with Card">Proceed to Payment</button></div>
        </div>
      </div>
</template>
<script>


export default {
    data: function(){
        return {
        }
    },
    props:{
      amount: [String,Number],
      fullname: String,
      email: String,
    },
    methods:{
    },
    mounted(){
 
    }
}
</script>

<style scoped>

</style>
